/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultTemplateRequest } from '../../models/api-response-paged-result-template-request';
import { PagedRequestSearchTemplateRequest } from '../../models/paged-request-search-template-request';

export interface SearchTemplateRequests$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestSearchTemplateRequest
}

export function searchTemplateRequests(http: HttpClient, rootUrl: string, params: SearchTemplateRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultTemplateRequest>> {
  const rb = new RequestBuilder(rootUrl, searchTemplateRequests.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultTemplateRequest>;
    })
  );
}

searchTemplateRequests.PATH = '/v1/api/ui/template-request/search';
